// extracted by mini-css-extract-plugin
module.exports = {"row":"PaymentTermsAndConditions_row__3D--n"};